import Select from "@components/FormFields/Select"
import { EffiePatternWrapper } from "@components/styles"
import { keyframes } from "@stitches/react"
import { styled, theme } from "@theme/stitches.config"
import { ResponsiveMasonry } from "react-responsive-masonry"

export const GalleryWrapper = styled("div", {
    display: "flex",
    position: "relative",
    width: "100%",
    flexWrap: "wrap"
})

export const StyledSelectWrapper = styled("div", {
    marginLeft: "auto",
    marginTop: "auto",
    width: 370,
    "@mdDown": {
        mt: 32,
        marginLeft: 0,
        flexDirection: "column",
        width: "100%"
    }
})

export const Left = styled("div", {
    display: "flex",
    flexDirection: "column",
    flex: "1 0 50%",
    "& button": {
        mt: 28
    },
    "@mdDown": {
        pb: 19
    }
})

export const StyledSelect = styled(Select, {
    width: "100%",
    border: `1px solid ${theme.colors.N50}`,
    "& span": {
        textTransform: "uppercase"
    }
})

export const Subtitle = styled("div", {
    color: theme.colors.effieGold,
    mb: 24
})

export const StyledEffiePatternWrapper = styled(EffiePatternWrapper, {
    zIndex: -2,
    transform: "scale(1.5)",
    "@smDown": {
        transform: "translateY(50%) scale(2.0)"
    },
    "& svg": {
        width: "100%"
    }
})

export const StyledResponsiveMasonry = styled(ResponsiveMasonry, {
    display: "flex",
    flex: "1 0 100%"
})

export const StyledImage = styled("div", {
    cursor: "pointer",
    "& img": {
        objectFit: 'cover',
        objectPosition: 'center',
        width: '100%',
        borderRadius: 6
    }
    // "& > img, & > .gatsby-image-wrapper": {
    //     borderRadius: 6,
    //     display: "block",
    //     width: "100%",
    //     height: "100%",
    //     objectFit: "cover"
    // }
})

export const Nav = styled("div", {
    display: "flex",
    position: "absolute",
    top: 35,
    right: 90,
    zIndex: 3,
    mr: 48,
    justifyContent: "flex-end",
    alignItems: "center",
    pointerEvents: "all",
    "& & .swiper-pagination-bullet": {
        border: `1px solid ${theme.colors.N0}`
    },
    "& .swiper-pagination-bullet-active": {
        backgroundColor: theme.colors.effieGold
    },
    "@mdUp": {
        marginTop: 0
    },
    "@smDown": {
        display: "none"
    }
})

export const Next = styled("div", {
    outline: "none",
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparant",
    border: `1px solid ${theme.colors.N0}`,
    width: 48,
    height: 48,
    borderRadius: "100%",
    marginRight: 10,
    cursor: "pointer",
    transition: "background 0.2s ease",
    padding: 0,
    appearance: "none",
    "@mdUp": {
        marginLeft: 10,
        marginRight: 0
    },
    "&::before": {
        content: "''",
        display: "block",
        position: "relative",
        left: 0,
        top: 0,
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 16 16'%3E%3Cpath d='M7.89,0,6,1.87,10.69,6.5H0v3H10.69L6,14.13,7.89,16,16,8Z'/%3E%3C/svg%3E\")",
        backgroundSize: "14px auto",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width: 14,
        height: 15
    },
    variants: {
        disabled: {
            true: {
                opacity: 0.5,
                pointerEvents: "none"
            }
        }
    }
})

export const Prev = styled(Next, {
    "&::before": {
        transform: "scaleX(-1)",
        top: -1
    }
})

const rotate = keyframes({
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" }
})

export const Expand = styled("div", {
    opacity: 0,
    display: "flex",
    position: "absolute",
    transform: "translate3d(0, 0, 0)",
    transition: "opacity .2s ease-out",
    padding: "10%",
    "&::before": {
        borderRadius: "50%",
        content: "''",
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        border: `2px dotted ${theme.colors.N0}`,
        animation: `${rotate} 12s linear infinite`
    },
    "& svg": {
        width: 19,
        height: 19
    },
    "@smDown": {
        display: "none"
    }
})

export const Item = styled("div", {
    backgroundColor: "#000",
    borderRadius: 6,
    position: "relative",
    width: "100%",
    "&:hover": {
        "& .gatsby-image-wrapper": {
            "@smUp": {
                opacity: 0.4,
                transition: "opacity .2s ease-out"
            }
        },
        [`${Expand}`]: {
            opacity: 1,
            transition: "opacity .2s ease-out"
        }
    },
    "& > div": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
})
